import { SegmentedControl } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '../i18n.js';
import classes from './LanguageSwitch.module.css';

/** EN/TR seçimi; koyu üst barda `inverted`. */
export function LanguageSwitch({ inverted = false }: { inverted?: boolean }) {
  const { t, i18n } = useTranslation();
  return (
    <SegmentedControl
      size="xs"
      radius="xl"
      value={i18n.resolvedLanguage ?? 'en'}
      onChange={(language) => void i18n.changeLanguage(language)}
      data={LANGUAGES.map((language) => ({ value: language, label: t(`language.${language}`) }))}
      aria-label={t('language.label')}
      className={inverted ? classes.inverted : classes.root}
    />
  );
}
